import React, { useEffect } from "react";
import Cards from "../../components/cards/account";

const Connect = ({ setPath }) => {
  useEffect(() => {
    document.title = "Daxa - Account";

    setPath(window.location.pathname);
  }, []);

  return (
    <>
      <Cards />
    </>
  );
};

export default Connect;
